import MonthlyReportSection from './MonthlyReportSection';

export default MonthlyReportSection;
